import { render, staticRenderFns } from "./ObraVisualHero.vue?vue&type=template&id=06eca5f9"
import script from "./ObraVisualHero.vue?vue&type=script&lang=js"
export * from "./ObraVisualHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports